module.exports = __webpack_public_path__ + "static/media/portfolio5.5d6a4735.png";